import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import LibraryApiCall from 'LibraryApiCall';
import config from 'config';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import 'LIBRARY/Components/Invoices/AddBill/addBill.css';
import { Base64 } from 'js-base64';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import axios from 'axios';


let apiPath = '/api/accounting/accounting.php';

class AddBill extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vendorId: this.props.vendorId,
            uniqueId: this.props.uniqueId,
            vendorName: this.props.vendorName,
            vendorNameTemp: this.props.vendorName,
            vendorIdTemp: this.props.vendorId,
            poAmount: this.props.poAmount,
            billDate: this.props.billDate,
            billNumber: this.props.billNumber,
            dueDate: this.props.dueDate,
            // linkTo: this.props.linkTo,
            taxType: this.props.taxType,
            note: this.props.note,
            attachments: this.props.attachments,
            attachmentCount: this.props.attachmentCount,
            taxValueAmount: 0,
            index: 1,
            assetCategoryDetails: this.props.assetCategoryDetails,
            totalAmount: this.props.totalAmount,
            taxAmount: '',
            subTotalAmount: 0,
            taxAmount: 0,
            attachmentJson: this.props.attachmentJson,

            // SUCCESS MODAL VARIABLES
            successModal: false,
            successModalType: '',
            successMessage: '',

            // VARIABLES FOR SELECTIONS
            poData: [],
            categoryData: [],
            selectedPOName: this.props.poName,
            poId: this.props.poId,
            poIdTemp: this.props.poId,
            vendorName: this.props.vendorName,
            vendorNameTemp: this.props.vendorName,

            billDateWarning: '',
            billNumberWarning: '',
            totalAmountWarning: '',
            linkToWarning: '',
            assetCategoryWarning: '',
            assetAmountWarning: '',
            assetTaxWarning: '',
            fileSelectionWarning: '',

            // VARIABLES TO SELECT PURCHASE ORDER
            purchaseOrderModal: false,
            pageIndex: 1,
            limit: 10,
            seriesData: [],
            seriesId: '',
            searchPOName: '',
            searchVendorName: '',
            filterApplied: false,
            isPurchaseOrderFetching: false,

            // VARIABLES FOR ATTACHMENT EDIT
            attachFileArray: [],
            message: '',
            status: '',
            removeFile: '',
            deleteAttachmentModal: false,
            disableButton: false
        };

        // if (this.props.isEditMode) {
        //     this.calculateTotalAmount();
        // }
    }

    componentDidMount() {
        // METHOD TO GET PO LIST
        this.getPOList();

        // METHOD TO GET SERIES DATA
        this.getSeriesData();

        // METHOD TO GET CATEGORY LIST
        this.getCategoryDetails();

        // if (this.props.isEditMode) {
        //     this.calculateTotalAmount();
        // }

    }


    // METHOD TO GET VENDOR DETAILS
    getPOList = async () => {
        this.setState({
            isPurchaseOrderFetching: true,
            poData: []
        });

        let requestData = {
            "instituteId": config.institute_id,
            "page_index": this.state.pageIndex,
            "limit": this.state.limit,
            "filterSeriesId": this.state.seriesId,
            "filterSeriesCounter": this.state.searchPOName,
            "filterVendorName": this.state.searchVendorName
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'accounting_getPurchaseOrder',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPOList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    isPurchaseOrderFetching: false
                });
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    poData: apiResult,
                    totalCount: jsonResponse.APIResult.Total
                });
            }
            else {
                this.setState({
                    isPurchaseOrderFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while fetching vendor data. Please try again later.'
                });
            }
        }
    }

    // API METHOD TO GET SERIES DATA
    getSeriesData = async () => {
        this.setState({
            isSeriesFetching: true,
            seriesData: [],
        });

        let requestData = {
            "institute_id": config.institute_id,
            "limit": this.state.limit,
            "page_index": this.state.pageIndex
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'accounting_getAllPOSeries',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getSeriesData()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    isSeriesFetching: false
                });
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    seriesData: apiResult
                });
            }
            else {
                this.setState({ isSeriesFetching: false });
            }
        }
    }

    // METHOD TO GET CATEGORY DETAILS
    getCategoryDetails = async () => {
        this.setState({
            isCategoryFetching: true,
            categoryList: []
        });

        let requestData = {
            "instituteId": config.institute_id,
            'page_index': 1,
            'limit': 1000
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'accounting_getCategoryList',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getCategoryDetails()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                Object.keys(apiResult).map(categoryId => {
                    apiResult[categoryId]['categoryId'] = categoryId;
                });
                this.setState({
                    categoryData: apiResult
                });

            }
            else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while fetching categories. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLICK ON INPUT TYPE FILE
    getAttachmentClick = () => {
        document.getElementById('attachment-files').click();
    }

    // METHOD TO EMPTY DATA ON FILE CLICK
    onFileClick = (e) => {
        e.target.value = "";
    }

    // METHOD TO GET ATTACHMENT FILES
    getAttachments = (e) => {
        let attachments = this.state.attachments;
        let validData = true;
        Object.values(e.target.files).map(file => {

            let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
            let fileSize = file.size / 1048576;
            if (fileExtension != 'pdf' || fileExtension != 'jpeg' || fileExtension != 'jpg' || fileExtension != 'png') {
                this.setState({
                    fileSelectionWarning: 'Please select files with .jpeg, .jpg, .png, .pdf only.'
                });
                validData = false;
            } else {
                this.setState({
                    fileSelectionWarning: ''
                });
                validData = true;
            }

            if (fileSize > 5) {
                this.setState({
                    fileSelectionWarning: 'Please select file less than 5MB.'
                });
                validData = false;
            } else {
                this.setState({
                    fileSelectionWarning: ''
                });
                validData = true;
            }

            if (validData) {
                attachments.push(file);
                this.setState({
                    attachments,
                    attachmentCount: attachments.length,
                    fileSelectionWarning: ''
                });
            }
        });
    }

    // METHOD TO CLICK ON INPUT TYPE FILE
    getAttachmentFile = () => {
        document.getElementById('editAttachment').click();
    }

    // METHOD TO EMPTY DATA ON FILE CLICK
    onEditFileClick = (e) => {
        e.target.value = "";
    }

    // METHOD TO GET ATTACHMENT
    getAttachment = (e) => {
        let attachFileArray = this.state.attachFileArray;
        // attachFileArray.push(e.target.files[0]);
        // this.setState({
        //     attachFileArray
        // });

        let validData = true;
        Object.values(e.target.files).map(file => {

            let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
            let fileSize = file.size / 1048576;
            if (fileExtension != 'pdf' || fileExtension != 'jpeg' || fileExtension != 'jpg' || fileExtension != 'png') {
                this.setState({
                    fileSelectionWarning: 'Please select files with .jpeg, .jpg, .png, .pdf only.'
                });
                validData = false;
            } else {
                this.setState({
                    fileSelectionWarning: ''
                });
                validData = true;
            }

            if (fileSize > 5) {
                this.setState({
                    fileSelectionWarning: 'Please select file less than 5MB.'
                });
                validData = false;
            } else {
                this.setState({
                    fileSelectionWarning: ''
                });
                validData = true;
            }

            if (validData) {
                // attachments.push(file);
                // this.setState({
                //     attachments,
                //     attachmentCount: attachments.length,
                //     fileSelectionWarning: ''
                // });
                attachFileArray.push(file);
                this.setState({
                    attachFileArray,
                    fileSelectionWarning: ''
                });
            }
        });
    }

    // METHOD TO ADD OBJECT IN CATEGORY
    addCategory = () => {
        let index = this.state.index;
        let assetCategoryDetails = this.state.assetCategoryDetails;
        assetCategoryDetails[index] = {
            'index': index,
            "categoryId": '',
            'description': '',
            'amount': 0,
            'taxValue': ''
        };

        this.setState({
            assetCategoryDetails,
            index: index + 1
        });
    }

    // METHOD TO DELETE ASSET CATEGORY
    deleteCategory = (categoryIndex) => {
        let assetCategoryDetails = this.state.assetCategoryDetails;

        delete assetCategoryDetails[categoryIndex];

        this.setState({
            assetCategoryDetails
        },
            // () => {
            //     this.calculateTotalAmount();
            // }
        );
    }

    // METHOD TO CALCULATE TOTAL AMOUNT
    // calculateTotalAmount = () => {
    //     let assetCategoryDetails = this.state.assetCategoryDetails;
    //     let totalAmount = 0;
    //     let taxAmount = 0;
    //     let subTotalAmount = 0;

    //     Object.values(assetCategoryDetails).map(assetCategory => {
    //         let taxValueAmount = assetCategory.taxValue == '' || assetCategory.taxValue == undefined ? 0 : assetCategory.taxValue.split('/')[0];
    //         taxAmount = (parseFloat(taxAmount) + parseFloat(assetCategory.amount - (assetCategory.amount - (assetCategory.amount * taxValueAmount)))).toFixed(3);
    //         if (this.state.taxType == 'inclusive') {
    //             totalAmount = parseFloat(parseFloat(totalAmount) + parseFloat(assetCategory.amount)).toFixed(3);
    //             subTotalAmount = parseFloat(parseFloat(totalAmount) - parseFloat(taxAmount)).toFixed(3);
    //         } else {
    //             subTotalAmount = parseFloat(parseFloat(subTotalAmount) + parseFloat(assetCategory.amount)).toFixed(3);
    //             totalAmount = parseFloat(parseFloat(subTotalAmount) + parseFloat(taxAmount)).toFixed(3);
    //         }
    //     });

    //     this.setState({
    //         subTotalAmount: subTotalAmount,
    //         totalAmount: totalAmount,
    //         taxAmount: taxAmount
    //     });
    // }

    // METHOD TO UPDATE CATEGORY ID
    updateCategoryId = (e, categoryIndex) => {
        let assetCategoryDetails = this.state.assetCategoryDetails;
        if (e.target.value.length > 0) {
            this.setState({
                assetCategoryWarning: ''
            });
            assetCategoryDetails[categoryIndex].categoryId = e.target.value;
        } else {
            this.setState({
                assetCategoryWarning: 'Please select asset category.'
            });
            assetCategoryDetails[categoryIndex].categoryId = e.target.value;
        }

        this.setState({
            assetCategoryDetails
        });
    }

    // METHOD TO UPDATE CATEGORY DESCRIPTION
    updateCategoryDescription = (e, categoryIndex) => {
        let assetCategoryDetails = this.state.assetCategoryDetails;

        assetCategoryDetails[categoryIndex].description = e.target.value;

        this.setState({
            assetCategoryDetails
        });
    }

    // METHOD TO UPDATE CATEGORY AMOUNT
    updateAmount = (e, categoryIndex) => {
        let assetCategoryDetails = this.state.assetCategoryDetails;
        if (e.target.value.length > 0) {
            this.setState({
                assetAmountWarning: ''
            });
            assetCategoryDetails[categoryIndex].amount = e.target.value;
        } else {
            this.setState({
                assetAmountWarning: 'Please enter amount for category.'
            });
            assetCategoryDetails[categoryIndex].amount = e.target.value;
        }

        this.setState({
            assetCategoryDetails
        },
            //  () => {
            //     this.calculateTotalAmount();
            // }
        );
    }

    // METHOD TO ADD Bill
    addBill = async () => {
        let validData = true;

        if (this.state.billDate.length == 0) {
            this.setState({
                billDateWarning: 'Please enter bill date.'
            });
            validData = false;
        }

        if (this.state.billNumber.length == 0) {
            this.setState({
                billNumberWarning: 'Please enter bill number.'
            });
            validData = false;
        }

        if (this.state.totalAmount.length == 0) {
            this.setState({
                totalAmountWarning: 'Please enter amount.'
            });
            validData = false;
        }


        if (validData) {

            if (!this.props.isEditMode) {
                Object.values(this.state.attachments).map(file => {
                    let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
                    let fileSize = file.size / 1048576;
                    if (fileExtension != 'pdf' || fileExtension != 'jpeg' || fileExtension != 'jpg' || fileExtension != 'png') {
                        this.setState({
                            fileSelectionWarning: 'Please select files with .jpeg, .jpg, .png, .pdf only.'
                        });
                        validData = false;
                    } else {
                        this.setState({
                            fileSelectionWarning: ''
                        });
                        validData = true;
                    }

                    if (fileSize > 5) {
                        this.setState({
                            fileSelectionWarning: 'Please select file less than 5MB.'
                        });
                        validData = false;
                    } else {
                        this.setState({
                            fileSelectionWarning: ''
                        });
                        validData = true;
                    }
                });
            }

            this.setState({
                disableButton: true
            });
            let formData = new FormData();
            if (this.props.isEditMode) {
                let requestData = {
                    'uniqueId': this.state.uniqueId,
                    "instituteId": config.institute_id,
                    "vendorId": this.state.vendorId,
                    "purchaseOrderId": this.state.poId,
                    "billDate": this.state.billDate,
                    "dueDate": this.state.dueDate,
                    "billNumber": this.state.billNumber,
                    "note": this.state.note,
                    "linkTo": "Library",
                    "assetCategoryDetails": this.state.assetCategoryDetails,
                    "facultyId": config.faculty_id,
                    "taxType": this.state.taxType,
                    "totalAmount": this.state.totalAmount,
                };

                let jsonResponse = await LibraryApiCall.makeApiCall(
                    'accounting_updateBill',
                    requestData,
                    apiPath
                );

                if (jsonResponse.expired) {
                    setTimeout(() => {
                        this.addBill()
                    }, 1000);
                } else {
                    if (jsonResponse.success) {
                        let apiResult = jsonResponse.APIResult;
                        if (apiResult.status == 'success') {
                            this.setState({
                                status: 'success',
                                message: apiResult.message
                            });
                        } else {
                            this.setState({
                                status: 'warning',
                                message: apiResult.message
                            });
                        }
                    }
                    else {
                        this.setState({
                            status: 'error',
                            message: 'Something went wrong while updating expense. Please try again later.'
                        });
                    }
                }
                this.props.getMessage(this.state.status, this.state.message);
                this.props.closeAddBillModal();
            } else {
                formData.append('accounting_addBill', true);
                formData.append('data', Base64.encode(JSON.stringify({
                    "instituteId": config.institute_id,
                    "vendorId": this.state.vendorId,
                    "purchaseOrderId": this.state.poId,
                    "billDate": this.state.billDate,
                    "dueDate": this.state.dueDate,
                    "billNumber": this.state.billNumber,
                    "note": this.state.note,
                    "linkTo": "Library",
                    "assetCategoryDetails": this.state.assetCategoryDetails,
                    "facultyId": config.faculty_id,
                    "taxType": this.state.taxType,
                    "totalAmount": this.state.totalAmount,
                    "academicYear": config.academicYear
                })));

                Object.values(this.state.attachments).map(file => {
                    formData.append('file[]', file);
                });

                let parameterData = JSON.stringify({
                    source: 'app',
                    uid: config.faculty_id,
                    email: config.emailId,
                    role: 'instructor'
                });
                formData.append('tokenInputParameter', Base64.encode(parameterData));

                const headers = {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                    "Authorization": "Basic " + config.user_token
                };

                await axios.post(
                    config.RootUrl + "/api/accounting/accounting.php",
                    formData,
                    {
                        headers: headers,
                    }
                ).then(response => {
                    if (response.data.success == 'true') {
                        if (response.data.status == 'success') {
                            this.setState({
                                status: 'success',
                                message: response.data.message
                            });
                        }
                        else {
                            this.setState({
                                status: 'warning',
                                message: response.data.message
                            });
                        }
                    } else {
                        this.setState({
                            status: 'error',
                            message: 'Something went wrong while adding bill. Please try again later.'
                        });
                    }
                });
            }
            this.props.getMessage(this.state.status, this.state.message);
            this.props.closeAddBillModal();
        }
    }

    // METHOD TO GET PURCHASE ORDER DETAILS
    getPurchaseOrder = () => {
        this.setState({
            purchaseOrderModal: true
        });
    }

    // METHOD TO UPDATE PAGINATION
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber
        }, () => {
            this.getPOList();
        });
    }

    // METHOD TO RETURN PURCHASE ORDER SELECTION MODAL
    returnPurchaseOrderModal = () => {
        const seriesList = Object.values(this.state.seriesData).map(series => {
            return (
                <option value={series.UniqueId}>{series.seriesText}</option>
            );
        });
        return (
            <div className={this.state.purchaseOrderModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="POModalContainer" >
                    <div className="modal-content">

                        <div className="modal-header modalHeaders">
                            <span style={{ fontSize: "24px", color: '#FFFFFF' }}>Purchase Order</span>
                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#FFFFFF" onClick={() => this.closePOModal()} style={{ cursor: "pointer" }} />
                        </div>

                        <div className="modal-body addPOSeriesModal">
                            <div className="filter-values">
                                <div className="po-series col-md-4" style={{ paddingLeft: 0 }}>
                                    <label>Select Series</label>
                                    <select id="series-selction" value={this.state.seriesId} className="form-control" onChange={(e) => this.setState({ seriesId: e.target.value })}>
                                        <option value="">Select Series</option>
                                        {seriesList}
                                    </select>
                                </div>
                                <div className="po-name col-md-4">
                                    <label>Series Counter</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter search text"
                                        value={this.state.searchPOName}
                                        onChange={(e) => this.setState({ searchPOName: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4" style={{ paddingRight: 0 }}>
                                    <label>Vendor Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.searchVendorName}
                                        placeholder="Search vendor name"
                                        onChange={(e) => this.setState({ searchVendorName: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className="search-button">
                                <button className="btn btn-outline-primary waves-effect" onClick={() => this.setState({ filterApplied: true, pageIndex: 1 }, () => { this.getPOList(); })}>Search</button>
                                <button className="btn btn-primary" onClick={() => this.setState({ filterApplied: false, seriesId: '', searchPOName: '', searchVendorName: '' }, () => { this.getPOList(); })}>Clear</button>
                            </div>
                            <div className="podata-table">
                                <table className="table table-responsive-sm table-hovered table-bordered">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Purchase Order Name</th>
                                            <th>Series</th>
                                            <th>Vendor Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.isPurchaseOrderFetching ?
                                                <tr>
                                                    <td colSpan={12}>
                                                        <ButtonLoader />
                                                    </td>
                                                </tr>
                                                :
                                                Object.values(this.state.poData).length > 0 ?
                                                    Object.values(this.state.poData).map(purchaseOrder => {
                                                        return (
                                                            <tr key={purchaseOrder.Uniqueid}>
                                                                <td className="tableRows">
                                                                    <input
                                                                        type="radio"
                                                                        value={purchaseOrder.Uniqueid}
                                                                        selected={purchaseOrder.Uniqueid == this.state.poIdTemp}
                                                                        onChange={() => this.selectPO(purchaseOrder)}
                                                                        name="purchaseOrder"
                                                                    />
                                                                </td>
                                                                <td className="tableRows">{purchaseOrder.seriesTitle + purchaseOrder.seriesCounter}</td>
                                                                <td className="tableRows">{purchaseOrder.seriesTitle}</td>
                                                                <td className="tableRows">{purchaseOrder.vendorName}</td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    this.state.filterApplied ?
                                                        <tr>
                                                            <td colSpan="4">No purchase order found as per applied filter.</td>
                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td colSpan="4">No purchase order added yet. Please add purchase order and then add bill.</td>
                                                        </tr>
                                        }
                                    </tbody>
                                </table>
                                {
                                    Object.values(this.state.poData).length > 0 &&
                                    <div id="settingPaginationContainer">
                                        <Pagination
                                            activePage={this.state.pageIndex}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.totalCount}
                                            pageRangeDisplayed={3}
                                            onChange={(num) => this.updatePaginationCount(num)}
                                        />
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="modal-footer">
                            <div id="addAssetButtonContainer">
                                <button className="btn btn-outline-primary waves-effect" onClick={this.addPO}>Add</button>

                                <button className="btn btn-primary" onClick={() => this.closePOModal()}>Cancel</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO SELECT PURCHASE ORDER
    selectPO = (purchaseOrder) => {
        this.setState({
            selectedPONameTemp: purchaseOrder.seriesTitle + purchaseOrder.seriesCounter,
            poIdTemp: purchaseOrder.Uniqueid,
            vendorNameTemp: purchaseOrder.vendorName,
            vendorIdTemp: purchaseOrder.vendorId,
            poAmountTemp: purchaseOrder.prDetails.poAmount
        });
    }

    // METHOD TO ADD PO 
    addPO = () => {
        this.setState({
            selectedPOName: this.state.selectedPONameTemp,
            poId: this.state.poIdTemp,
            poIdTemp: this.state.poIdTemp,
            vendorName: this.state.vendorNameTemp,
            vendorId: this.state.vendorIdTemp,
            poAmount: this.state.poAmountTemp,
            purchaseOrderModal: false,
        });
    }

    // METHOD TO CLOSE PO MODAL
    closePOModal = () => {
        this.setState({
            purchaseOrderModal: false,
            poId: this.state.poId,
            vendorName: this.state.vendorName,
            vendorId: this.state.vendorId,
            poAmount: this.state.poAmount,
            poIdTemp: this.state.poId,
            vendorNameTemp: this.state.vendorNameTemp,
            vendorIdTemp: this.state.poAmountTemp,
            poAmountTemp: this.state.poAmountTemp
        });
    }

    // METHOD TO CLOSE ADD EXPENSE MODAL
    closeAddBill = () => {
        this.props.closeAddBillModal();
    }

    // METHOD TO ADD EDIT ATTCHMENT TO BILL
    addAttachmentToExpense = async (file) => {
        let formData = new FormData();
        formData.append('accounting_addExpenseAttachment', true);
        formData.append('data', Base64.encode(JSON.stringify({
            "instituteId": config.institute_id,
            "facultyId": config.faculty_id,
            "uniqueId": this.state.uniqueId
        })));
        formData.append('file', file);
        let parameterData = JSON.stringify({
            source: 'app',
            uid: config.faculty_id,
            email: config.emailId,
            role: 'instructor'
        });
        formData.append('tokenInputParameter', Base64.encode(parameterData));

        const headers = {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Authorization": "Basic " + config.user_token
        };

        await axios.post(
            config.RootUrl + "/api/accounting/accounting.php",
            formData,
            {
                headers: headers,
                // onUploadProgress: (ProgressEvent) => {
                //     const {loaded, total} = ProgressEvent;
                //     let percent = Math.floor( (loaded * 100) / total );
                //     document.getElementById('progressMessage').textContent = 'Uploading File: '+percent + '%';
                //     document.getElementById('progressBar').style.width = percent + '%';
                //     document.getElementById('progressBar').style.color = 'black';
                // }
            }
        ).then(response => {
            if (response.data.success) {
                let attachFileArray = this.state.attachFileArray;
                if (response.data.status == 'success') {
                    attachFileArray = attachFileArray.filter(attachFile => attachFile.name != file.name);
                    this.setState({
                        attachFileArray,
                        successModal: true,
                        successMessage: response.data.message,
                        attachmentJson: response.data.attachmentArray,
                        attachmentCount: response.data.attachmentArray.length,
                        successModalType: 'success'
                    }, () => {
                        this.props.getExpenses();
                    });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: response.data.message
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding attachments to expense. Please try again later.'
                });
            }
        });
    }

    // METHOD TO GIVE POPUP TO REMOVE ATTACHMENT FROM EXPENSE
    removeExpenseAttachment = (file) => {

        this.setState({
            deleteAttachmentModal: true,
            removeFile: file
        });
    }

    // METHOD TO RETURN DELETE MODAL FOR ATTACHMENT
    returnDeleteAttachmentModal = () => {
        return (
            <div className={this.state.deleteAttachmentModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modalDataContainer" >
                    <div className="modal-content successContent">

                        <div className="modal-header modalHeaders deleteAttachmentModal text-white">
                            <h5 style={{ textTransform: "capitalize", fontSize: 20 }}>Are You Sure?</h5>
                            <FontAwesomeIcon icon={['fas', 'times']} color="white" size="lg" onClick={() => this.closeDeleteAttachmentModal()} style={{ cursor: "pointer" }} />
                        </div>

                        <div className="modal-body successBody">

                            <p style={{ marginTop: 20, fontSize: 16, textAlign: "center" }}>Are you sure you want to delete attachment ?</p>

                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-outline-primary" onClick={() => this.removeAttachmentFromExpense()}>Yes</button>
                            <button className="btn btn-primary" onClick={() => this.closeDeleteAttachmentModal()}>No</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CLOSE DELETE ATTACHMENT MODAL
    closeDeleteAttachmentModal = () => {
        this.setState({
            deleteAttachmentModal: false
        });
    }

    // METHOD TO REMOVE ATTACHMENT FROM EXPENSE
    removeAttachmentFromExpense = async () => {
        let requestData = {
            "uniqueId": this.state.uniqueId,
            "instituteId": config.institute_id,
            'facultyId': config.faculty_id,
            'attachment': this.state.removeFile
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'accounting_deleteExpensesAttachment',
            requestData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.removeAttachmentFromExpense()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        attachmentJson: apiResult.attachmentArray,
                        attachmentCount: apiResult.attachmentArray.length
                    }, () => {
                        this.props.getExpenses();
                    });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            }
            else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while removing attachment from expense. Please try again later.'
                });
            }
        }
        this.closeDeleteAttachmentModal();
    }

    // METHOD TO REMOVE ATTACHMENT
    removeAttachment = (file) => {
        let attachFileArray = this.state.attachFileArray;
        attachFileArray = attachFileArray.filter(attachFile => attachFile.name != file.name);
        this.setState({
            attachFileArray
        });
    }

    // METHOD TO REMOVE ADD ATTACHMENT
    removeAddAttachment = (file) => {

        let attachments = this.state.attachments;
        attachments = attachments.filter(attachFile => attachFile.name != file.name);

        this.setState({
            attachments,
            attachmentCount: attachments.length
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render() {
        return (
            <div id="addExpenseSideMenu" style={{
                display: this.props.addBillModal ? 'flex' : 'none'
            }}>
                <div id="addExpenseDataContainer">

                    <div id="addExpenseHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddBill()} style={{ cursor: "pointer" }} className="" />
                        <h3 className="col-11">{this.props.isEditMode ? 'Edit' : 'Add'}</h3>
                    </div>

                    <div id="addExpenseBody">
                        <div className="payeeSelection col-md-12">
                            <label>Purchase Order</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.selectedPOName}
                                placeholder="Click to select purchase order"
                                onChange={(e) => e.preventDefault()}
                                onClick={this.getPurchaseOrder}
                            />
                        </div>
                        <div className="col-md-12 pl-1 pr-1">
                            <div className="row">
                                <div className="vendorName col-md-6">
                                    <h5><label>{this.state.vendorName}</label></h5>
                                </div>
                                <div className="vendorAmount col-md-6">
                                    <h5><label>Rs. {this.state.poAmount}</label></h5>
                                </div>
                            </div>
                        </div>
                        <div className=" col-md-12" style={{ paddingLeft: '1px', paddingRight: '1px', paddingTop: '15px' }}>
                            <div className="row">
                                <div className="bill-number col-md-6">
                                    <label>Bill Number <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        type="text"
                                        placeholder="Enter Bill Number"
                                        className="form-control"
                                        value={this.state.billNumber}
                                        maxLength={50}
                                        // onChange={(event) => event.target.value.length > 0 ? this.setState({ billNumberWarning: '', billNumber: event.target.value.replace(/[^a-zA-Z0-9-_]/g, '') }) : this.setState({ billNumber: event.target.value.replace(/[^a-zA-Z0-9-_]/g, ''), billNumberWarning: 'Please enter bill number.' })}
                                        onChange={(event) => event.target.value.length > 0 ? this.setState({ billNumberWarning: '', billNumber: event.target.value}) : this.setState({ billNumber: event.target.value, billNumberWarning: 'Please enter bill number.' })}
                                    />
                                    <p style={{ display: this.state.billNumberWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.billNumberWarning}</p>
                                </div>
                                <div className="bill-date col-md-6">
                                    <label>Bill Date <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={this.state.billDate}
                                        onChange={(event) => event.target.value.length > 0 ? this.setState({ billDateWarning: '', billDate: event.target.value }) : this.setState({ billDateWarning: 'Please enter bill date.', billDate: event.target.value })}
                                    />
                                    <p style={{ display: this.state.billDateWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.billDateWarning}</p>
                                </div>
                            </div>
                        </div>
                        <div className="payment-details">
                            <div className="row">
                                {/* <div className="billDate col-md-12">
                                    <label>Due Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={this.state.dueDate}
                                        onChange={(event) => event.target.value.length > 0 ? this.setState({ dueDate: event.target.value }) : this.setState({ dueDate: event.target.value})}
                                    />
                                </div> */}
                                <div className="billDate col-md-12">
                                    <label>Amount (In Rs.) <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter amount"
                                        value={this.state.totalAmount}
                                        // onChange={(event) => event.target.value.length > 0 ? this.setState({ totalAmountWarning: '', totalAmount: event.target.value }) : this.setState({ totalAmount: event.target.value, totalAmountWarning: 'Please enter amount.' })}
                                        onChange={(event) => {
                                            // Check if the input is a positive number
                                            if (/^\d+$/.test(event.target.value) || event.target.value === '') {
                                                this.setState({
                                                    totalAmountWarning: '',
                                                    totalAmount: event.target.value,
                                                });
                                            } else {
                                                this.setState({
                                                    totalAmountWarning: 'Please enter a valid amount.',
                                                });
                                            }
                                        }}
                                    />
                                    <p style={{ display: this.state.totalAmountWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.totalAmountWarning}</p>
                                </div>
                            </div>
                        </div>

                        <div className="note-Tax col-md-12 pt-2" style={{ padding: 0 }}>
                            <div className="note-description col-md-12">
                                <label>Note</label>
                                <textarea
                                    className="form-control"
                                    value={this.state.note}
                                    placeholder="Enter note"
                                    onChange={(event) => this.setState({ note: event.target.value })}
                                    style={{ resize: 'none' }}
                                    rows="6"
                                    maxLength={500}
                                />
                                <p className="info-msg">(Maximum 500 characters are allowed.)</p>
                            </div>
                        </div>
                        {
                            this.props.isEditMode == false &&
                            <div className="attachments col-md-12">
                                <p className="total-attachments">Total {this.state.attachmentCount} Attachment</p>
                                {
                                    this.state.attachmentCount > 0 &&
                                    Object.values(this.state.attachments).map((attachment, index) => {
                                        return (
                                            <p className="attachedFile-name">
                                                {attachment.name}
                                                <FontAwesomeIcon icon={['fas', 'times']} size="lg" title="Click to remove file" color="#880000" style={{ cursor: "pointer", marginLeft: 10 }} onClick={() => this.removeAddAttachment(attachment)} />
                                            </p>
                                        );
                                    })
                                }
                                <input
                                    type="file"
                                    id="attachment-files"
                                    onClick={(e) => this.onFileClick(e)}
                                    onChange={(e) => this.getAttachments(e)}
                                    multiple
                                    style={{ display: 'none' }}
                                    accept=".pdf, .jpeg, .jpg, .png"
                                />
                                <button type="button" role="button" className="btn filesButton" onClick={this.getAttachmentClick}>
                                    <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" style={{ cursor: "pointer", marginRight: 10 }} />
                                    Choose Files
                                </button>
                                <p style={{ color: '#818181', fontSize: 12, marginTop: 5 }}>Maximum file upload size - 5MB</p>
                                <p style={{ display: this.state.fileSelectionWarning.length > 0 ? 'block' : 'none', color: 'red' }}>{this.state.fileSelectionWarning}</p>
                            </div>
                        }
                        {
                            this.props.isEditMode &&
                            <div id="addExpenseFooter" className="col-md-12" style={{ textAlign: 'right' }}>
                                <button className="btn btn-primary" onClick={this.addBill} disabled={this.state.disableButton}>Update</button>
                                <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddBill()}>Cancel</button>
                            </div>
                        }
                        {
                            this.props.isEditMode == true &&
                            <div style={{ width: '100%', paddingTop: '2px' }}>
                                <div className="editAttachment text-white">
                                    &nbsp;&nbsp; Attachments
                                </div>
                            </div>
                        }
                        {
                            this.props.isEditMode == true &&
                            <div className="attachments col-md-12" style={{ marginBottom: 20 }}>

                                <p className="total-attachments">Total {this.state.attachmentCount} Attachment</p>
                                {
                                    this.state.attachmentCount > 0 &&
                                    this.state.attachmentJson.map((attachment) => {

                                        return (
                                            <p className="attachedFile-name">
                                                {attachment}
                                                <FontAwesomeIcon icon={['fas', 'times']} size="lg" title="Click to remove file" color="#880000" style={{ cursor: "pointer", marginLeft: 10 }} onClick={() => this.removeExpenseAttachment(attachment)} />
                                            </p>
                                        );
                                    })
                                }
                                <input
                                    type="file"
                                    id="editAttachment"
                                    // onClick={(e) => this.onEditFileClick(e)}
                                    onChange={(e) => this.getAttachment(e)}
                                    style={{ display: 'none' }}
                                    accept=".pdf, .jpeg, .jpg, .png"
                                />
                                <button type="button" role="button" className="btn filesButton" onClick={this.getAttachmentFile}>
                                    <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" style={{ cursor: "pointer", marginRight: 10 }} />
                                    Choose File
                                </button>
                                {
                                    Object.values(this.state.attachFileArray).length > 0 &&
                                    Object.values(this.state.attachFileArray).map((file, index) => {
                                        return (
                                            <p className="attachedFile-name">
                                                {file.name}
                                                <FontAwesomeIcon icon={['fas', 'check']} size="lg" title="Click to upload file" color="#008000" style={{ cursor: "pointer", marginRight: 10, marginLeft: 10 }} onClick={() => this.addAttachmentToExpense(file)} />
                                                <FontAwesomeIcon icon={['fas', 'times']} size="lg" title="Click to remove file" color="#880000" style={{ cursor: "pointer", marginRight: 10 }} onClick={() => this.removeAttachment(file)} />
                                            </p>
                                        )
                                    })

                                }
                                <p style={{ color: '#818181', fontSize: 12, marginTop: 5 }}>Maximum file upload size - 5MB</p>
                                <p style={{ display: this.state.fileSelectionWarning.length > 0 ? 'block' : 'none', color: 'red' }}>{this.state.fileSelectionWarning}</p>
                            </div>
                        }
                    </div>
                    {
                        this.props.isEditMode == false &&
                        <div id="addExpenseFooter" style={{ marginBottom: 10 }}>
                            <button className="btn btn-primary" onClick={this.addBill} disabled={this.state.disableButton}>Add</button>
                            <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddBill()}>Cancel</button>
                        </div>
                    }

                </div>
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }

                {/* METHOD TO RETURN PURCHASE ORDER MODAL */}
                {this.returnPurchaseOrderModal()}

                {/* METHOD TO RETURN DELETE ATTACH MODAL */}
                {this.returnDeleteAttachmentModal()}
            </div >
        );
    }
}

export default AddBill;